module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ChTitle",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "id": "ch1aa"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1a"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rch1"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("YOU’RE MY INSPIRATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('i', [_vm._v("It’s always interesting to see where the architects of pop culture get their ideas. Some of these may surprise you.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("E")]), _c('b', [_vm._v("DWARD SCISSORHANDS.")]), _vm._v(" Screenwriter Caroline Thompson based the character’s mannerisms on her dog: “She was the most soulful, yearning creature I ever met. She didn’t need language—she communicated with her eyes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('i', [_c('b', [_vm._v("THE BIG LEBOWSKI.")])]), _vm._v(" The Coen brothers’ cult classic was an update of Raymond Chandler’s 1939 noir novel "), _c('i', [_vm._v("The Big Sleep.")]), _vm._v(" They used the L.A. setting and many of the characters, but changed Philip Marlowe, P.I., to Jeffrey “The Dude” Lebowski.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("THE HUNGER GAMES.")])]), _vm._v(" Suzanne Collins’s inspiration for her 2008 novel about teenagers forced to fight each other in a dystopian future came to her while she was watching TV. She was flipping back and forth between "), _c('i', [_vm._v("Survivor")]), _vm._v(" and coverage of the Iraq war when the two “began to blur in this very unsettling way.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("PHILIP J. FRY.")]), _vm._v(" The lead character on the cartoon "), _c('i', [_vm._v("Futurama")]), _vm._v(" wears the same clothes—blue jeans, red jacket, and white T-shirt—and has the same blond hair as Jim Stark. Who’s that? James Dean’s character in the 1955 film "), _c('i', [_vm._v("Rebel Without a Cause")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('i', [_c('b', [_vm._v("THE BIG BANG THEORY.")])]), _vm._v(" Show creator Chuck Lorre named the two leads—Sheldon and Leonard—after legendary producer Sheldon Leonard ("), _c('i', [_vm._v("The Andy Griffith Show")]), _vm._v(" and "), _c('i', [_vm._v("The Dick Van Dyke Show")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("“CALIFORNIA GURLS.”")]), _vm._v(" Katy Perry’s 2010 hit single was going to be called “California Girls” until Perry’s manager asked her to change the spelling to honor Alex Chilton, lead singer of the band Big Star, who’d recently died. The title is a nod to the band’s 1974 song “September Gurls.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("SEVERUS SNAPE.")]), _vm._v(" J. K. Rowling based the character on her short-tempered high school chemistry teacher, John Nettleship, who had long dark hair and a “malodorous laboratory.” Said Nettleship, “I knew I was strict but I didn’t think I was "), _c('i', [_vm._v("that")]), _vm._v(" bad.”")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center7"
  }, [_c('span', [_c('b', [_vm._v("Count ’em: On average, an adult human has about five million body hairs.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c63ad10a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter001.vue
// module id = 81
// module chunks = 0